export const uk = {
    'relevance-match': 'автотаргетинг'
};
